import { Form } from '../../services/form';
import { BankSlipModel } from '../../models/bankslip.model';
import { RechargeService } from '../../services/recharge.service';
import { ResponsibleService } from '../../services/responsible.service';
import { RechargeModel } from '../../models/recharge.model';
import { NotificationService } from '../../notification/swal/notification.service';
import { DependentService } from '../../services/dependent.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { DependentMeepServerModel } from '../../models/dependent.model';
import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { MaskHelper } from '../../helpers/mask';
import { InputSelectModel } from '../input-select/inputSelect.model';
import Auth from '../../helpers/auth';
import { UserModel } from '../../models/user.model';
import { ICustomWindow, WindowRefService } from '../../services/window.service';
import { PixService } from '../../services/paymentPix.service';
import { PixModel } from '../../models/paymentPix.model';
import { Subscription } from 'rxjs';
import { interval } from 'rxjs/observable/interval';
import { PixResponseModel } from '../../models/paymentPixResponse.model';

@Component({
  selector: 'app-recharge',
  templateUrl: './recharge.component.html',
  styleUrls: ['./recharge.component.less']
})
export class RechargeComponent extends Form implements OnInit, OnDestroy {
  currentView: 'paymentApproved' | 'showPix' | 'rechargeForm' = 'rechargeForm';
  dependent: DependentMeepServerModel = new DependentMeepServerModel();
  paymentMethods: InputSelectModel[] = new Array<InputSelectModel>();
  rechargeModel: RechargeModel = new RechargeModel();
  paymentMethod: any;
  routeParams: Params;
  creditCard = true;
  bankslip = false;
  hasPaymentMethods = true;
  enableRecharge: boolean = false;
  windowRef: ICustomWindow;
  pix = false;
  showPix = false;
  qrCodeLink: string = '';
  pollingInterval: any = null;
  pixResponse: any = null;
  remainingTime: number = 0;
  timerSubscription: Subscription | null = null;
  paymentApproved: boolean = false;
  pixExpired: boolean = false;
  qrcodeImage: string = '';
  isLoading: boolean = false;

  constructor(
    window: WindowRefService,
    private router: Router,
    private route: ActivatedRoute,
    private dependentService: DependentService,
    private responsibleService: ResponsibleService,
    private notificationService: NotificationService,
    private pixService: PixService,
    private rechargeService: RechargeService,
    private cdr: ChangeDetectorRef,
  ) {
    super();
    this.windowRef = window.nativeWindow;
    this.route.params.subscribe((params: Params) => {
      this.routeParams = params;
    });
  }

  ngOnInit() {
    const user = UserModel.fromJsonToUserModel(<UserModel>Auth.getUser());
    if (!user.ableToRecharge()) {
      this.notificationService.showAlertNotification('Complete seu cadastro para ter acesso à recarga.').then(() => {
        this.router.navigate(['general/minhaConta']);
      });
    } else {
      this.dependentService.getFromMeepServer(this.routeParams['id'])
        .then((_dependent: DependentMeepServerModel) => {
          _dependent.ValorTaxaRecarga = _dependent.ValorTaxaRecarga === undefined ? 0 : _dependent.ValorTaxaRecarga;
          this.dependent = _dependent;
          this.rechargeModel.dependent = _dependent;
          this.getPaymentMethods();
          this.displayMessage();
        })
        .catch((err) => {
          this.notificationService.showErrorNotification(err.message);
        });
    }
    this.loadMercadoPagoSecurity();
  }

  ngOnDestroy() {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }

  cancelPix() {
    this.pixResponse = null;
    this.remainingTime = 0;
    this.showPix = false;
    this.currentView = 'rechargeForm';
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
      this.timerSubscription = null;
    }

    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
      this.pollingInterval = null;
    }

    this.switchPaymentMethod('card');
  }

  startTimer() {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }

    this.timerSubscription = interval(1000).subscribe(() => {
      if (this.remainingTime > 0) {
        this.remainingTime -= 1;
        this.pixExpired = false;
      } else {
        this.showPix = true;
        this.pixExpired = true;

      }
    });
  }

  pixRecharge() {
    this.rechargeModel.amount = MaskHelper._removeCurrency(this.rechargeModel.amountToShow);
    const amountNotZero = MaskHelper._removeCurrency(this.rechargeModel.amount) !== 0;
    const isFormValid = this.rechargeModel.amount && amountNotZero;
    if(isFormValid) {
    const pixRequest: PixModel = {
      cartaoCashlessId: this.dependent.Id,
      historicoAssociacaoId: this.dependent.HistoricoAssociacaoId,
      valor: MaskHelper._removeCurrency(this.rechargeModel.amountToShow)
    };

    this.pixService.paymentPix(pixRequest)
      .then((response: PixResponseModel) => {
        this.pixResponse = response;
        this.remainingTime = 900;
        this.showPix = true;
        this.qrCodeLink = response.QrCodeLink;
        this.startTimer();
        this.startPollingForPixStatus(response.OrderId);
        this.qrcodeImage = `data:image/png;base64,${response.QrCodeBase64}`
        this.currentView = 'showPix';
      })
      .catch((err) => {
        this.notificationService.showErrorNotification(err.message);
      });
    }
  }

  startPollingForPixStatus(paymentId: string) {
      const intervalTime = 20000; // 20 segundos
      this.pollingInterval = setInterval(() => {
        this.pixService.getPixStatus(paymentId)
        .then((statusResponse: any) => {
          if (statusResponse.status === 'approved') {
            clearInterval(this.pollingInterval);
            this.pollingInterval = null;
            this.paymentApproved = true;
            this.showPix = false;
            this.currentView = 'paymentApproved';
            this.cdr.detectChanges();
          }
        })
        .catch((err) => {
          console.error('Erro ao verificar o status do pagamento:', err);
        });
      }, intervalTime);
  }

  navigateToHome() {
    this.currentView = 'paymentApproved';
    this.router.navigate(['general/home']);
  }

  switchPaymentMethod(method: 'card' | 'pix') {
    this.currentView = 'rechargeForm';
    this.creditCard = method === 'card';
    this.pix = method === 'pix';

    if (method === 'card') {
      this.cancelPix();
    }
  }

  copyQrCodeLink() {
    if (this.qrCodeLink) {
      (navigator as any).clipboard.writeText(this.qrCodeLink)
        .then(() => {
          this.notificationService.showSuccessNotification('Código Pix copiado para a área de transferência!');
        })
        .catch(() => {
          this.notificationService.showErrorNotification('Erro ao copiar o código Pix.');
        });
    }
  }

  private displayMessage() {
    // Bernoulli Go-Save Me
    // Colégio Apoio - Totum
    const excludedLocals: string[] = ['B5629881-E9C5-A978-A09C-8FB6159DD650', 'C23AC9C5-A2EC-D00E-B9A9-127BF36F48FD'];
    this.enableRecharge = !excludedLocals.includes(this.dependent.LocalClienteId.toUpperCase());
  }

  private getPaymentMethods() {
    this.responsibleService.getCreditCards()
      .then((_responsible) => {
        if (_responsible.length === 0) {
          this.hasPaymentMethods = false;
        }
        _responsible.forEach((creditCard) => {
          this.paymentMethods.push({ title: `**** **** **** ${creditCard.finalNumero}`, value: creditCard });
        });
      })
      .catch((err) => {
        this.notificationService.showErrorNotification(err.message);
      });
  }
  goToCard(id: string) {
    this.router.navigate([`general/registrarCartao/`]);
  }

  bankSlipRecharge() {
    this.rechargeModel.amount = MaskHelper._removeCurrency(this.rechargeModel.amountToShow);
    if (MaskHelper.removeRechargeMask(this.rechargeModel).amount > 6) {
      const bankSlip = new BankSlipModel();
      bankSlip.CartaoCashlessTag = this.dependent.Tag;
      bankSlip.Valor = MaskHelper.removeRechargeMask(this.rechargeModel).amount;

      this.rechargeService.rechargeWithBankSlip(bankSlip)
        .then((_bankSlip: BankSlipModel) => {
          this.notificationService.showSuccessNotification('Ok', {
            html: `<a target="_system" href="${_bankSlip.urlBoleto}">Clique aqui para acessar seu boleto!</a>`
          });
        })
        .catch((err) => {
          this.notificationService.showErrorNotification(err.message);
        });
    } else {
      this.notificationService.showErrorNotification('O valor precisa ser maior que R$ 6.00');
    }
  }

  creditCardRecharge() {
    this.isLoading = true;
    const amount = MaskHelper._removeCurrency(this.rechargeModel.amount);
    const fingerprint = this.windowRef.MP_DEVICE_SESSION_ID || '';
    this.rechargeService.recharge(
      this.paymentMethod.id,
      this.rechargeModel.cvv,
      this.dependent.Id,
      this.dependent.HistoricoAssociacaoId,
      amount,
      fingerprint)
      .then(() => {
        this.isLoading = false;
        this.notificationService.showSuccessNotification('Recarga realizada com sucesso!')
          .then(() => {
            this.router.navigate([`general/dependentesSingle/${this.dependent.Tag}/${this.routeParams['tipo']}`]);
          });
      })
      .catch((err) => {
        this.isLoading = false;
        this.notificationService.showErrorNotification(err.message);
      });
  }

  recharge() {
    this.rechargeModel.amount = MaskHelper._removeCurrency(this.rechargeModel.amountToShow);
    const amountNotZero = MaskHelper._removeCurrency(this.rechargeModel.amount) !== 0;
    const isFormValid = this.dependent.Id && this.getFormStatus() && this.rechargeModel.amount && amountNotZero;
    if (isFormValid) {
      this.creditCardRecharge();
    } else {
      this.notificationService.showErrorNotification('Preencha o todos os campos!');
    }
  }

  getTotalRecharge() {
    const value = !!!this.rechargeModel.amountToShow ? "0" : this.rechargeModel.amountToShow;
    return (parseFloat(MaskHelper._removeCurrency(value).toString()) + this.rechargeModel.dependent.ValorTaxaRecarga).toLocaleString("pt-BR", { maximumFractionDigits: 2, minimumFractionDigits: 2 });
  }

  private loadMercadoPagoSecurity() {
    const existingScript = document.getElementById('mercadoPagoSecurity');

    if (!existingScript) {
      const script = document.createElement('script');
      script.src = 'https://www.mercadopago.com/v2/security.js';
      script.id = 'mercadoPagoSecurity';
      script.setAttribute('view', 'checkout');
      document.body.appendChild(script);
    }
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/recharge/recharge.component.ts